import { dataUserStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserStar = /*#__PURE__*/createIcon(dataUserStar)
export default IconUserStar
